// extracted by mini-css-extract-plugin
export default {"container":"style_container__j8Ute","number":"style_number__cPpK0"};